import { install } from '@webitel/ui-sdk/src/plugins/breakpoint/breakpoint.plugin';

export default {
	install,
};
